import Helpers from "@/services/helpers";
import { SET_SHUFFLE } from "@/store/mutation-types";

export default {
  name: "shuffle",
  install(ctx) {
    Helpers.mapStore(ctx, {
      shuffle: {
        get: "player/shuffle",
        set: `player/${SET_SHUFFLE}`
      }
    });

    let indexes = [];

    const fillIndexes = function() {
      indexes = this.tracklistIds
        .map((id, index) => index)
        .filter(index => index !== this.currentIndex);
    }.bind(ctx);

    const getRandomIndex = function() {
      if (!indexes.length) {
        fillIndexes();
      }

      const max = indexes.length - 1;
      const random = (max * Math.random()) | 0;
      const index = indexes.splice(random, 1)[0];

      return index;
    }.bind(ctx);

    const toggle = function() {
      this.shuffle = !this.shuffle;
    }.bind(ctx);

    return {
      fill: fillIndexes,
      getIndex: getRandomIndex,
      toggle
    };
  }
};
